// extracted by mini-css-extract-plugin
module.exports = {"loader-color":"var(--accent-7)","loader":"loader_loader__HVNnM","l20":"loader_l20__3AArn"};